import * as CONSTANTS from '../constants/actions/tools';
import * as FILTER_CONSTANTS from '../constants/actions/filters';

/**
 * @name showAll
 * @function 
 * @description toggles display of parameters modal
 */
export const showAll = () => {
    return dispatch => dispatch({ type: FILTER_CONSTANTS.SHOW_ALL });
}

/**
 * @name toggleFilters
 * @function 
 * @description toggles display of parameters modal
 */
export const toggleFilters = () => {
    return dispatch => dispatch({ type: CONSTANTS.TOGGLE_FILTERS });
}

/**
 * @name toggleParameters
 * @function 
 * @description toggles display of parameters modal
 */
export const toggleParameters = () => {
    return dispatch => dispatch({ type: CONSTANTS.TOGGLE_PARAMETERS });
}